/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Render_Required_BadgeInputs */



/**
* | output |
* | --- |
* | "RENDER" |
*
* @param {Event_Ad_Render_Required_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_render_required_badge = /** @type {((inputs?: Event_Ad_Render_Required_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Render_Required_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "de") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "it") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "ru") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "es") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "ja") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "hi") return /** @type {LocalizedString} */ ("RENDER")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("RENDER")
	return /** @type {LocalizedString} */ ("RENDER")
});